// extracted by mini-css-extract-plugin
module.exports = {"Block":"Block_Block__87jVs","Active":"Block_Active__ITzBf","fullWidth":"Block_fullWidth__PQAdt"};